module.exports = __webpack_public_path__ + "img/btn-apple@2x.35c3511d.png";